import { http } from '@/http/axios';
import type { DashboardStats, DashboardWebinar } from '../types';

export const dashboardService = {
  getUpcomingWebinars: async (workspaceId: number): Promise<DashboardWebinar[]> => {
    const response = await http.get<any[]>(`/workspaces/${workspaceId}/webinars/upcoming`);

    return response.data.map((item) => ({
      id: String(item.webinarId),
      sessionId: item.sessionId,
      sessionIdentifier: item.sessionIdentifier,
      title: item.title || '',
      startDate: item.plannedDate || '',
      timezone: item.timezone ?? null,
      status: item.status === 'IN_PROGRESS' ? 'LIVE' : 'UPCOMING',
      participantsCount: item.participantsCount || 0,
      waitingRoomCount: 0, // Computed via metrics buffer on back-end if needed
      coverUrl: item.coverUrl,
      isEvergreen: item.sessionType === 'EVERGREEN',
      type: item.type,
      presenters: item.presenters?.map((presenter: any) => ({
        id: presenter.fullname,
        firstName: presenter.fullname ? presenter.fullname.split(' ')[0] : '',
        lastName: presenter.fullname ? presenter.fullname.split(' ')[1] || '' : '',
        job: presenter.job,
        accessUrl: presenter.accessUrl,
        pictureUrl: presenter.pictureUrl,
        role: presenter.role === 'MODERATOR' ? 'moderator' : 'presenter',
      })),
      moderators: item.moderators?.map((moderator: any) => ({
        id: moderator.fullname,
        firstName: moderator.fullname ? moderator.fullname.split(' ')[0] : '',
        lastName: moderator.fullname ? moderator.fullname.split(' ')[1] || '' : '',
        job: moderator.job,
        accessUrl: moderator.accessUrl,
        pictureUrl: moderator.pictureUrl,
        role: 'moderator',
      })),
      speakers: item.speakers?.map((speaker: any) => ({
        id: speaker.fullname,
        firstName: speaker.fullname ? speaker.fullname.split(' ')[0] : '',
        lastName: speaker.fullname ? speaker.fullname.split(' ')[1] || '' : '',
        job: speaker.job,
        accessUrl: speaker.accessUrl,
        role: 'guest',
        accessCode: speaker.accessCode,
      })),
      registrationUrl: item.registrationUrl,
      accessCodeEnabled: item.accessCodeEnabled,
    }));
  },

  getStats: async (workspaceId: number, from?: string, to?: string): Promise<DashboardStats> => {
    const response = await http.get<DashboardStats>(
      `/workspaces/${workspaceId}/analytics/summary`,
      { params: { from, to } },
    );
    return response.data;
  },
};
